import React, { useState } from 'react';
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { FaArrowAltCircleRight } from "react-icons/fa";

/** Replace avatars/paths with your own assets */
const reviewsData = [
  {
    name: 'Elias V.',
    avatar: '/images/avatars/elias.jpg',
    rating: 5,
    quote:
      'Mistress Lady Cinder reads you like a spellbook—one look, and my obedience clicked into place. Precise, intoxicating, unforgettable.',
  },
  {
    name: 'J. Hart',
    avatar: '/images/avatars/jhart.jpg',
    rating: 5,
    quote:
      'A velvet-gloved takeover. Ritual, rhythm, and total command—She turns anticipation into devotion and leaves you aching to return.',
  },
  {
    name: 'S. Marlowe',
    avatar: '/images/avatars/smarlowe.jpg',
    rating: 4,
    quote:
      'Cinematic control without a wasted breath. Grounded, safe, and ruthlessly elegant—the session lingered for days.',
  },
];

function Stars({ count = 5 }) {
  return (
    <div className="grid grid-flow-col auto-cols-max gap-1 justify-center">
      {Array.from({ length: count }).map((_, i) => (
        <svg
          key={i}
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="w-5 h-5 drop-shadow-[0_0_6px_rgba(74,222,128,0.6)] fill-green-400"
        >
          <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.46L12 17.98 6.2 20.36l1.11-6.46-4.7-4.58 6.49-.94L12 2.5z" />
        </svg>
      ))}
    </div>
  );
}

function HomeReviewSection() {
  const [index, setIndex] = useState(0);
  const current = reviewsData[index];

  const prev = () => setIndex((i) => (i === 0 ? reviewsData.length - 1 : i - 1));
  const next = () => setIndex((i) => (i === reviewsData.length - 1 ? 0 : i + 1));

  return (
    <section
      aria-labelledby="reviews-heading"
      className="grid w-full py-16 bg-neutral-900"
    >
      <div className="grid gap-10 px-6 sm:px-10 md:px-16 lg:px-24">
        <div className="grid lg:grid-cols-2 place-self-center lg:max-w-[70%] gap-8 items-center">
          {/* Heading */}
          <header className="grid text-center lg:text-left">
            <h2
              id="reviews-heading"
              className="font-titleFont text-4xl sm:text-5xl lg:text-6xl tracking-wide text-white"
            >
              <span className="block">DEVOTION &amp; PRAISE</span>
              <span className="block text-green-400/90">Mistress Lady Cinder</span>
              <span className="block">SESSION REVIEWS</span>
            </h2>
          </header>

          {/* Review Card */}
          <figure className="grid relative px-8">
            {/* Glow frame */}
            <div className="grid rounded-xl border border-green-400/60 p-6 sm:p-8 md:p-10 bg-black/40 shadow-[inset_0_0_30px_rgba(74,222,128,0.25),0_0_40px_rgba(74,222,128,0.15)]">
              <div className="grid gap-6 text-center">
                <Stars count={current.rating} />

                <blockquote
                  className="text-neutral-200 leading-relaxed"
                  aria-live="polite"
                >
                  “{current.quote}”
                </blockquote>

                <figcaption className="grid grid-flow-col auto-cols-max gap-3 justify-center items-center">
                  {/* Avatar */}
                  <span className="grid w-10 h-10 rounded-full overflow-hidden ring-2 ring-green-400/70">
                    <img
                      src={current.avatar}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </span>
                  <span className="text-white font-medium">{current.name}</span>
                </figcaption>
              </div>
            </div>

            {/* Prev / Next */}
            <div className="pointer-events-none grid absolute inset-0 px-8">
              <div className="grid grid-cols-[auto_1fr_auto] items-center">
                <button
                  onClick={prev}
                  className="pointer-events-auto grid place-items-center w-10 h-10 translate-x-[-1.25rem] rounded-full border border-green-400/60 bg-black/60 hover:bg-black/80 focus:outline-none focus:ring-2 focus:ring-green-400"
                  aria-label="Previous review"
                >
                  <FaArrowAltCircleLeft className='text-green-400' />
                </button>

                <span className="sr-only">Review carousel</span>

                <button
                  onClick={next}
                  className="pointer-events-auto grid place-items-center w-10 h-10 justify-self-end translate-x-[1.25rem] rounded-full border border-green-400/60 bg-black/60 hover:bg-black/80 focus:outline-none focus:ring-2 focus:ring-green-400"
                  aria-label="Next review"
                >
                  <FaArrowAltCircleRight className='text-green-400' />
                </button>
              </div>
            </div>

            {/* Dots */}
            <div className="grid grid-flow-col auto-cols-max gap-2 justify-center mt-6">
              {reviewsData.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  aria-label={`Go to review ${i + 1}`}
                  className={`h-2 w-6 rounded-full ${
                    i === index ? 'bg-green-400' : 'bg-green-400/30'
                  }`}
                />
              ))}
            </div>
          </figure>
        </div>
      </div>
    </section>
  );
}

export default HomeReviewSection;
